import { useCallback, useEffect, useState } from 'react';
import { fetchEpisodeFeed } from '@models/episodes/episodeRepository';

const initialState = {
  episodes: [],
  feedMetadata: null,
  loading: true,
  error: null
};

function isAbortError(error) {
  return error?.name === 'AbortError';
}

export function useEpisodesController() {
  const [state, setState] = useState(initialState);

  const loadEpisodes = useCallback(async (signal) => {
    setState((currentState) => ({
      ...currentState,
      loading: true,
      error: null
    }));

    try {
      const result = await fetchEpisodeFeed({ signal });
      if (signal?.aborted) {
        return;
      }
      setState({
        ...result,
        loading: false,
        error: null
      });
    } catch (error) {
      if (isAbortError(error)) {
        return;
      }

      console.error('Error fetching episodes:', error);
      setState((currentState) => ({
        ...currentState,
        loading: false,
        error: error.message
      }));
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    loadEpisodes(controller.signal);

    return () => controller.abort();
  }, [loadEpisodes]);

  const refetch = useCallback(() => loadEpisodes(), [loadEpisodes]);

  return {
    ...state,
    refetch
  };
}
